import {AppState} from '../reducer';

export const timerSelector = (state: AppState): number => state.timerReducer.timeElapsed;
